const TemporaryTimeEntryWarning = ({ tempProjectName }) => {
  return (
    <>
      <div
        className="modal fade add-new-timesheet-modal"
        id="tempProjectWarning"
        tabIndex="-1"
        aria-labelledby="tempProjectWarningLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div style={{ maxHeight: "600px" }} className="modal-content">
            <div className="modal-header">
              <p
                className="modal-title font-weight-bold"
                id="tempProjectWarningLabel"
              >
                There are temporary project time entries in the time sheet
              </p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <div className="add-new-project-modal">
                <div className="input-flex">
                  <label htmlFor="recipient-name" className="col-form-label">
                    <h6>Temporary projects</h6>
                  </label>
                </div>
                <div className="input-flex">
                  <p>{tempProjectName}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TemporaryTimeEntryWarning;
